import { useNavigate, NavigateFunction, NavigateOptions, To } from 'react-router-dom';
import { handleRouterContextError } from '@/lib/services/routerContextService';

/**
 * Safe wrapper around useNavigate with fallback to window.location
 * when used outside Router context.
 */
export function useSafeNavigate(): NavigateFunction {
  try {
    return useNavigate();
  } catch (error) {
    // Handle Router context error and provide fallback
    handleRouterContextError('useNavigate', error, 'window_fallback');
    
    // Return fallback navigate function
    const fallbackNavigate = ((to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        // Handle history navigation (back/forward)
        window.history.go(to);
      } else {
        const path = typeof to === 'string' ? to : to.pathname || '/';
        if (options?.replace) {
          window.location.replace(path);
        } else {
          window.location.href = path;
        }
      }
    }) as NavigateFunction;
    
    return fallbackNavigate;
  }
}
